import React from "react";
import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { CrudPage } from "../components/CrudPage";
import { banks } from "../services/api";

const columns = [
  {
    header: "نام بانک",
    accessor: "name",
    render: (item: any) => item.name || "—",
  },
  {
    header: "کد بانک",
    accessor: "bankCode",
    render: (item: any) => item.bankCode || "—",
  },
  {
    header: "شناسه بانک سجام",
    accessor: "sejamBankId",
    render: (item: any) => item.sejamBankId || "—",
  },
];

type BankFormProps = {
  initialData?: any;
  onSubmit: (data: any) => void;
  onCancel: () => void;
};

const BankForm: React.FC<BankFormProps> = ({
  initialData,
  onSubmit,
  onCancel,
}) => {
  const safeInitialData = initialData || {};
  const [formData, setFormData] = React.useState({
    name: safeInitialData.name || "",
    bankCode: safeInitialData.bankCode || "",
    sejamBankId: safeInitialData.sejamBankId || "",
  });

  const inputBg = useColorModeValue("white", "#23272F");
  const inputBorder = useColorModeValue("#e5e7eb", "#444");
  const labelColor = useColorModeValue("gray.700", "gray.200");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((current) => ({
      ...current,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <VStack spacing={5} align="stretch" w="100%" py="10px">
        <FormControl isRequired>
          <FormLabel fontWeight="bold" color={labelColor}>
            نام بانک
          </FormLabel>
          <Input
            name="name"
            value={formData.name}
            onChange={handleChange}
            borderRadius="lg"
            bg={inputBg}
            borderColor={inputBorder}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel fontWeight="bold" color={labelColor}>
            کد بانک
          </FormLabel>
          <Input
            name="bankCode"
            value={formData.bankCode}
            onChange={handleChange}
            borderRadius="lg"
            bg={inputBg}
            borderColor={inputBorder}
            dir="ltr"
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel fontWeight="bold" color={labelColor}>
            شناسه بانک سجام
          </FormLabel>
          <Input
            name="sejamBankId"
            value={formData.sejamBankId}
            onChange={handleChange}
            borderRadius="lg"
            bg={inputBg}
            borderColor={inputBorder}
            dir="ltr"
          />
        </FormControl>

        <HStack spacing={3}>
          <Button type="submit" flex="1">
            ارسال
          </Button>
          <Button type="button" variant="outline" flex="1" onClick={onCancel}>
            انصراف
          </Button>
        </HStack>
      </VStack>
    </form>
  );
};

export const BanksPage: React.FC = () => {
  return (
    <CrudPage
      title="بانک‌ها"
      columns={columns}
      queryKey="banks"
      resourceName="banks"
      api={banks}
      FormComponent={BankForm}
    />
  );
};
